export const words = [
  "welcome_back",
  "hello_there",
  "memberID_or_mobile",
  "enter_memberID_or_mobile",
  "password",
  "enter_password",
  "forgot_password",
  "login",
  "dont_have_account",
  "sign_up",

  "welcome",
  "hello",
  "full_name",
  "enter_name",
  "dob",
  "choose_dob",
  "mobile_number",
  "enter_mobile",
  "gender",
  "male",
  "female",
  "state",
  "select_state",
  "city",
  "select_city",
  "send_otp",
  "already_have_account",

  "forgot_password_heading",
  "reset_password",
  "enter_memberID",

  "verification_code",
  "code_sent",
  "confirm",
  "resend_otp",

  "upload_profile_picture",
  "upload_your_picture",
  "camera",
  "gallery",

  "search_members",
  "list_of_members",

  "home",
  "search",
  "notification",
  "account",

  "filters",
  "age_range",
  "reset",
  "apply",

  "email",
  "age",
  "occupation",
  "marital_status",
  "follow",
  "unfollow",
  "followers",
  "following",
  "all_followers",
  "my_family",

  "profile",
  "change_password",
  "change_language",
  "create_family_accounts",
  "logout",
  "bio",
  "current_address",
  "permanent_address",

  "current_password",
  "enter_current_password",
  "new_password",
  "enter_new_password",
  "confirm_password",

  "no_family_data",
  "add_family_member",
  "enter_full_name",
  "relation",
  "choose_relation",
  "add",
];
